import {getSupabase} from './supabase'
import {resetCrmSync} from './crmSync'
import {isAuthStorageKey} from './crmAuthStorage'

function purgeClientAuthStorage(){
  try{
    for(const key of Object.keys(localStorage)){
      if(isAuthStorageKey(key))localStorage.removeItem(key)
    }
    for(const key of Object.keys(sessionStorage)){
      if(isAuthStorageKey(key))sessionStorage.removeItem(key)
    }
  }catch{/* storage unavailable; canonical signOut state remains authoritative */}
}

export async function signOutCrm():Promise<void>{
  resetCrmSync()
  const client=getSupabase()
  if(client){
    try{await client.auth.signOut({scope:'global'})}
    catch{/* continue with local purge so reload cannot restore the shell */}
  }
  purgeClientAuthStorage()
}
